export { default } from './UserAnketaForm';



// WEBPACK FOOTER //
// ./src/components/UserAccount/UserAnketaForm/index.js